module.exports = __webpack_public_path__ + "img/image04.5d53d04b.jpg";